import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const LOCATION_FIELDS = `
  id
  stateId
  name
  street
  city
  state
  postalCode { formatted, value}
  phoneNumber { formatted, value}
  releaseYardContact
  releaseYardEmail
  storageFee
  storageFeeText
  runningUnitsOnly
  equiplincContact {
    firstName
    lastName
    fullName
    phoneNumber { formatted }
  }
`

const LOCATION_VARIABLES = `
  $name: String
  $stateId: String
  $street: String
  $city: String
  $state: String
  $postalCode: String
  $phoneNumber: String
  $releaseYardContact: String
  $releaseYardEmail: String
  $storageFee: String
  $storageFeeText: String
  $runningUnitsOnly: Boolean
  $equiplincContactId: ID
`;

const LOCATION_ARGUMENTS = `
  name: $name
  stateId: $stateId
  street: $street
  city: $city
  state: $state
  postalCode: $postalCode
  phoneNumber: $phoneNumber
  releaseYardContact: $releaseYardContact
  releaseYardEmail: $releaseYardEmail
  storageFee: $storageFee
  storageFeeText: $storageFeeText
  runningUnitsOnly: $runningUnitsOnly
  equiplincContactId: $equiplincContactId
`;

const LOCATION_FIELDS_AND_ERRORS = `
  location {
    ${LOCATION_FIELDS}
  }
  ${ERRORS}
`;

export const LOCATIONS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    locationsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${LOCATION_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_LOCATION = gql`
  mutation CreateLocation(
    ${LOCATION_VARIABLES}
  ) {
    createLocation(
      ${LOCATION_ARGUMENTS}
    ) {
      ${LOCATION_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation UpdateLocation(
    $id: ID!
    ${LOCATION_VARIABLES}
  ) {
    updateLocation(
      id: $id
      ${LOCATION_ARGUMENTS}
    ) {
      ${LOCATION_FIELDS_AND_ERRORS}
    }
  }
`;

export const LOCATION = gql`
  query Location($id: ID!) {
    location(id: $id) {
      ${LOCATION_FIELDS}
    }
  }
`;

export const HIDE_LOCATION = gql`
  mutation HideLocation($id: ID!) {
    hideLocation(id: $id) {
      location {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const UNHIDE_LOCATION = gql`
  mutation UnhideLocation($id: ID!) {
    unhideLocation(id: $id) {
      location {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
